import { makeStyles, Theme, createStyles } from '@material-ui/core';
import React, { FC } from 'react';
import { ContactInfoData } from '../ContactsPage.types';

export type ContactInfoProps = {
  className?: string;
  data: ContactInfoData;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    name: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    position: {
      fontWeight: 300,
    },
    email: {},
    phone: {},
  }),
);

const ContactInfo: FC<ContactInfoProps> = ({ data }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <span className={classes.name}>{data.name}</span>
      <span className={classes.position}>{data.position}</span>
      <span className={classes.phone}>{data.phone}</span>
      <a href={`mailto:${data.email}`} className={classes.email}>
        {data.email}
      </a>
    </div>
  );
};

export default ContactInfo;
